import { Link } from "react-router-dom";
import NTPLogoModule from "ntp-logo-react";

import { legalLinks, resourceLinks } from "./landingContent";
import { COOKIE_BANNER_EVENT } from "../../components/CookieBanner/CookieBanner";

const NTPLogo =
  typeof NTPLogoModule === "function"
    ? NTPLogoModule
    : (NTPLogoModule as { default: typeof NTPLogoModule }).default;

export default function LandingFooter() {
  return (
    <footer className="landing-footer">
      <div className="landing-shell landing-footer__inner">
        <div>
          <p className="landing-footer__brand">AIFoiParcurs</p>
          <p className="landing-footer__copy">
            Foi de parcurs complete, date validate și evidență coerentă pentru firme care folosesc
            vehicule în activitate.
          </p>
          <div className="landing-footer__company">
            <p className="landing-footer__label">Date companie</p>
            <p>
              <Link to={{ pathname: "/", hash: "#visajtech" }}>Visaj Technologies SRL</Link>
            </p>
            <p>CUI 40191040</p>
            <p>Str. Rândunicii nr. 9, Giroc, Timiș</p>
            <p>Telefon: 0726678127</p>
          </div>
        </div>

        <div className="landing-footer__section">
          <p className="landing-footer__section-title">
            <Link to="/ghiduri">Ghiduri</Link>
          </p>
          <ul className="landing-footer__resources">
            {resourceLinks.map((link) => (
              <li key={link.href}>
                <Link to={link.href}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="landing-footer__links">
          {legalLinks.map((link) => (
            <Link key={link.label} to={link.href}>
              {link.label}
            </Link>
          ))}
          <button
            className="cookie-settings-link"
            onClick={() => window.dispatchEvent(new Event(COOKIE_BANNER_EVENT))}
          >
            Preferințe cookie-uri
          </button>
        </div>
      </div>
      <div className="landing-shell landing-footer__ntp" aria-label="NETOPIA Payments">
        <NTPLogo color="#ffffff" version="horizontal" secret="162263" />
      </div>
    </footer>
  );
}
